import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-financial-list',
  templateUrl: './financial-list.component.html',
  styleUrls: ['./financial-list.component.scss']
})
export class FinancialListComponent implements OnInit {
  role: string;

  financialTeacherList = [{
    title: 'ตารางกิจกรรม',
    link: 'workshop',
    imgUrl: '../assets/icons/desktop-calendar.png'
  }, {
    title: 'คอร์สเรียน',
    link: 'course',
    imgUrl: '../assets/icons/ebook.png'
  }, {
    title: 'แบบทดสอบ',
    link: 'measure',
    imgUrl: '../assets/icons/checklist.png'
  }];

  financialPsychoList = [{
    title: 'ตารางกิจกรรม',
    link: 'workshop',
    imgUrl: '../assets/icons/desktop-calendar.png'
  }];

  constructor(
    private homeService: HomeService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('รายการทางการเงิน');
    this.homeService.getRole().subscribe(res => {
      this.role = res.result.ROLE;
      // // console.log(this.role);
    })
  }

}
